import { Card, CardContent, CardHeader } from "../../ui/card"
import { VersionCardHeader } from "./version-card-header";
import { VideoSection } from "./video-section"
import { CreatorRemarksSection } from "./creator-remarks-section"
import { ClientRemarksSection } from "./client-remarks-section"
import { ScreenshotsSection } from "./screenshots-section"

export const VersionCard = ({ videoVersion, handleStatusChange }) => {
  return (
    <Card className="border-l-4 border-l-[#f06292]">
      <CardHeader>
        <VersionCardHeader
          versionNumber={videoVersion && videoVersion.versionNumber}
          status={videoVersion && videoVersion.status}
          submittedBy={videoVersion && videoVersion.submittedBy}
          createdAt={videoVersion && videoVersion.submittedDate}
          handleStatusChange={handleStatusChange}
          approvedBy={videoVersion && videoVersion.approvedBy}
          approvedByClient={videoVersion && videoVersion.approvedByClient}
          approvedOn={videoVersion && videoVersion.approvedOn}
        />
      </CardHeader>

      <CardContent className="space-y-6">
        <VideoSection videoUrl={videoVersion && videoVersion.videoLink} />
        <CreatorRemarksSection oyeCreatorRemark={videoVersion && videoVersion.oyeCreatorRemark}/>
        <ClientRemarksSection clientRemarks={videoVersion && videoVersion.clientRemark} />
        <ScreenshotsSection screenshots={videoVersion && videoVersion.screenShots} />
      </CardContent>
    </Card>
  )
}
